import React, {useState} from 'react';
import {FeaturesList, Item, SectionHeader} from '../utils/Styled';
import {Trans, useI18next} from 'gatsby-plugin-react-i18next';
import {MenuItemIcon} from '../utils/MenuItemIcon';
import {resources as resourcesList} from '../constants/resources';
import SoonIndicator from '../utils/SoonIndicator';
import {MenuLink, Props} from '../utils/types';
import {InternalPageLink} from 'components/links/Pages';
import {links, supportDocsUrl} from 'global.config';
import {AnchorLink} from 'components/AnchorLink';
import {Language, targetLanguage} from '../../../../locales/types';

export const Resources: React.FC<Props & {hideTitle?: boolean}> = ({itemClick, hideTitle}) => {
  const {language} = useI18next();
  const [origin] = useState(links.landing);

  return (
    <>
      {!hideTitle && (
        <SectionHeader marginTop="0">
          <Trans>Resources</Trans>
        </SectionHeader>
      )}
      <FeaturesList>
        {resourcesList.map((item: MenuLink) => (
          <Item key={item.slug}>
            <MenuItemIcon name={item.icon} />
            {item.slug ? (
              <InternalPageLink slug={item.slug} activeClassName="active" onClick={itemClick}>
                {item.title}
              </InternalPageLink>
            ) : item.to === 'blog' ? (
              <AnchorLink
                target="_self"
                href={`${origin + targetLanguage[(language as Language) || 'en']}/blog/`}>
                {item.title}
              </AnchorLink>
            ) : item.to === 'support' ? (
              <AnchorLink target="_blank" href={supportDocsUrl(language)}>
                {item.title}
              </AnchorLink>
            ) : item.to ? (
              <AnchorLink href={item.to} target="_blank">
                {item.title}
              </AnchorLink>
            ) : (
              item.title
            )}
            {item.beta && (
              <SoonIndicator>
                <Trans>BETA</Trans>
              </SoonIndicator>
            )}
          </Item>
        ))}
      </FeaturesList>
    </>
  );
};
